import type { CoopPayload } from '../../core/types/payloads/coop.types';
import { DEMO_CROSSWORD } from './crossword.engine';

export function demoCoopCrosswordPayload(): CoopPayload {
  return {
    title: 'Crucigrama de la clase',
    board: DEMO_CROSSWORD,
    settings: { turnUnit: 'participant', turnDurationSec: 45 },
  };
}

export function demoAnagramPayload(): CoopPayload {
  return {
    title: 'Fábrica de Anagramas',
    board: {
      kind: 'anagram',
      hint: 'Capital de Chile, reorganiza las letras del banco',
      answer: 'SANTIAGO',
      letterPool: ['S', 'A', 'N', 'T', 'I', 'A', 'G', 'O', 'R', 'E'],
    },
    settings: { turnUnit: 'team', turnDurationSec: 60 },
  };
}

export function demoChainPayload(): CoopPayload {
  return {
    title: 'Conectores en Cadena',
    board: {
      kind: 'chain',
      intro: 'Completa el texto con el conector lógico correcto en cada turno.',
      segments: [
        {
          id: 's1',
          textBefore: 'El volcán entró en erupción',
          textAfter: 'la población fue evacuada a tiempo.',
          correct: 'por lo tanto',
          choices: ['por lo tanto', 'sin embargo', 'aunque', 'además'],
        },
        {
          id: 's2',
          textBefore: 'Los científicos monitoreaban la actividad',
          textAfter: 'nadie esperaba una explosión tan pronto.',
          correct: 'sin embargo',
          choices: ['por eso', 'sin embargo', 'luego', 'por ejemplo'],
        },
        {
          id: 's3',
          textBefore: 'Se activó la alerta roja',
          textAfter: 'las escuelas suspendieron clases.',
          correct: 'y',
          choices: ['y', 'pero', 'aunque', 'o sea'],
        },
      ],
    },
    settings: { turnUnit: 'participant', turnDurationSec: 40 },
  };
}

export function demoPictionaryPayload(): CoopPayload {
  return {
    title: 'Pictionary Conceptual',
    board: {
      kind: 'draw-guess',
      prompt: 'Dibuja un concepto abstracto: la Justicia',
      sketchMode: 'concept',
    },
    settings: { turnUnit: 'participant', turnDurationSec: 90 },
  };
}

export function demoMelodySketchPayload(): CoopPayload {
  return {
    title: 'Lienzo del Sonido',
    board: {
      kind: 'draw-guess',
      prompt: 'Dibuja el contorno melódico que escuchaste (sube y baja de la melodía)',
      sketchMode: 'melody',
    },
    settings: { turnUnit: 'participant', turnDurationSec: 90 },
  };
}
